import { useLayoutEffect } from "react";

const useCenteredPage = (refElement) => {
    useLayoutEffect(() => {
        if (!refElement?.current) return;

        const headerHeight = document.querySelector('.MuiPaper-root').clientHeight;
        refElement.current.style.setProperty('height', `${window.innerHeight - headerHeight}px`, 'important');

        const handleResize = () => {
            const headerHeight = document.querySelector('.MuiPaper-root').clientHeight;
            refElement.current.style.setProperty('height', `${window.innerHeight - headerHeight}px`, 'important');
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize)

    }, [refElement]);
};

export default useCenteredPage;